// Score-derived room-player data.

import { useMemo } from 'react';
import { useRoomPlayerSelection } from './useRoomPlayerSelection';
import type { RoomPlayer } from '@airhead-games/shared/types';

interface UseRoomPlayerScoresReturn {
  winnersGame: RoomPlayer[];
  winnersTurn: RoomPlayer[];
}

export function useRoomPlayerScores(): UseRoomPlayerScoresReturn {
  const { selectPlayerData } = useRoomPlayerSelection();

  const winnersGame = useMemo((): RoomPlayer[] => {
    const sortedPlayers = selectPlayerData({
      sort: 'desc',
      sortField: 'scoreGame',
    });

    if (sortedPlayers.length === 0) return [];

    const highestScore = sortedPlayers[0].scoreGame;
    return sortedPlayers.filter((player) => player.scoreGame === highestScore);
  }, [selectPlayerData]);

  const winnersTurn = useMemo((): RoomPlayer[] => {
    const sortedPlayers = selectPlayerData({
      sort: 'desc',
      sortField: 'scoreTurn',
    });

    if (sortedPlayers.length === 0) return [];

    const highestScore = sortedPlayers[0].scoreTurn;
    return sortedPlayers.filter((player) => player.scoreTurn === highestScore);
  }, [selectPlayerData]);

  return {
    winnersGame,
    winnersTurn,
  };
}
